import { abGetDefaultCity } from '../ab/widgets-home';
import { $api } from '../y/api';
import { $fn } from '../y/fn';
import { $i18n, YI18NString } from '../y/i18n';
import { $time, YTime } from '../y/time';
import { YCountryId, YId, YTimeString } from '../y/types';
import { c_cities, CCityId } from './c-city';
import { CEventId } from './c-event';
import { CEventTagId } from './c-event-tag';

export interface CEventHomeListViewSession {
    time: YTimeString;
    is_bookable: boolean;
    is_drop_in: boolean;
}

export interface CEventHomeListView {
    id: CEventId;
    name: YI18NString;
    city_id: CCityId;
    slug: string;
    venue_name: string;
    event_tag_ids: CEventTagId[];
    sessions: CEventHomeListViewSession[];
    is_loyalty: boolean;
    rating_score?: number;
    picture_id: YId;
    popularity: number;
    dots: number;
    published_at: YTimeString;
    //TODOURGENT: actually have this
    has_videos: boolean;
}

export function cEventHomeListViewSessionTimeAfter(event: CEventHomeListView, when: YTime) {
    let bookable: YTime | undefined;
    for(const s of event.sessions) {
        const t = $time(s.time);
        if(t.after(when))
            return t;
        else if(!bookable)
            bookable = t;
    }
    return bookable;
}

export function cEventHomeListViewNextSessionTime(event: CEventHomeListView, after?: YTime) {
    let bookable = event.sessions.filter(s => s.is_bookable);
    if(bookable.length) {
        if(after) {
            const filtered_bookable = bookable.filter(s => $time(s.time).after(after));
            if(filtered_bookable.length)
                bookable = filtered_bookable;
        }
        if(bookable.length > 1)
            return $i18n.tl.several_dates;
        const text = $time(bookable[0].time).formatIn(bookable[0].is_drop_in ? 'd MMM' : 'd MMM, HH:mm', 'Europe/Stockholm');
        return text;
    }

    // if(model.videos && model.videos.length && this.isVideoAvailable(model.videos[0])) {
    //     const time = $time(model.videos[0].date);
    //     if(time.is_future) {
    //         return $i18n.tl.t_video_starts + ' ' + time.format('d MMM, HH:mm');
    //     } else if(time.add(model.length, $time.minute).is_future) {
    //         return $i18n.tl.t_video_live_now;
    //     }
    // }

    return;
}

export function cEventHomeListViewScreenLocation(event: CEventHomeListView) {
    return ['event', c_cities.maybe(event.city_id)!.slug, event.slug];
}

export function cEventHomeListFilterActive(e: CEventHomeListView) {
    return e.sessions.some(s => s.is_bookable);
}

export function cEventHomeListFilterFuture(e: CEventHomeListView) {
    return e.sessions.length > 0;
}

export function cEventHomeListFilterUpcoming(e: CEventHomeListView) {
    return e.sessions.some(s => s.is_bookable); //TODOURGENT: || has live stream
}

export function cEventHomeListFilterPast(e: CEventHomeListView) {
    return !e.sessions.length;
}

const getHomeListView = $fn.lazy1((sub_path: string) => {
    return $api.GET<CEventHomeListView[]>(`c/events/home_list_view/${sub_path}`);
})

export function cEventsHomeListViewFeaturedByCountry(country: YCountryId) {
    return getHomeListView(`featured/${country}`);
}

export function cEventsHomeListViewActiveByEventTag(event_tag_id: CEventTagId) {
    return getHomeListView(`active/by_event_tag/${event_tag_id}`);
}

export function cEventsHomeListViewActiveByCityId(city_id: CCityId = abGetDefaultCity().id) {
    return getHomeListView(`active/by_city/${city_id}`);
}
